import {
  isPermissionActive,
  type Permission,
} from '../../../../../app/pages/permissions/permissionMetadata'

type MenuPermission = Pick<Permission, 'name' | 'is_active'>

// As duas apresentações do menu usam as permissões efetivas do usuário.
// O catálogo de features ativas não representa uma concessão de acesso.
export function getMenuAccess(permissions: readonly MenuPermission[], superAdmin: boolean) {
  const names = permissions.filter(isPermissionActive).map((permission) => permission.name)
  const has = (name: string) => names.includes(name)
  const contains = (part: string) => names.some((name) => name.includes(part))

  return {
    home: true,
    unilever: names.some((name) => name.includes('unilever-') && name.includes('view')),
    cashback: names.some((name) => name.includes('cashback-') && name.includes('view')),
    conecta: contains('conecta-'),
    datatransfer: contains('datatransfer-'),
    reports: contains('reports-'),
    api: contains('api-'),
    infrapay: contains('infrapay-'),
    devops: contains('devops'),
    briefing: contains('briefing-'),
    campaigns: has('campaign-simulator-view'),
    ai: has('ai-view'),
    agentStudio: has('agent-studio-view'),
    platformReview: has('platform-review-view'),
    sellerMapping: has('seller-mapping-view'),
    administrative:
      superAdmin ||
      names.some(
        (name) =>
          [
            'analytics-view',
            'logs-view',
            'development-features-manage',
            'fechamentos-view',
          ].includes(name) ||
          name.includes('settings-') ||
          name.includes('users-view') ||
          name.includes('nps-view')
      ),
  }
}

export type MenuSectionId = keyof ReturnType<typeof getMenuAccess>
